package com.bulut.mecitogullari.core.network

import io.ktor.client.HttpClient
import io.ktor.client.plugins.DefaultRequest
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.logging.LogLevel
import io.ktor.client.plugins.logging.Logging
import io.ktor.http.ContentType
import io.ktor.http.contentType
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json

object ApiConfig {
    // TODO: point at the real backend when it is available.
    const val BASE_URL = "https://api.example.com/"
}

fun createJson(): Json = Json {
    ignoreUnknownKeys = true
    isLenient = true
    encodeDefaults = true
}

/**
 * Shared Ktor client. The engine is picked per platform from the
 * dependencies declared in shared/build.gradle.kts
 * (OkHttp on Android, Darwin on iOS, Js on web).
 */
fun createHttpClient(json: Json): HttpClient = HttpClient {
    install(ContentNegotiation) {
        json(json)
    }
    install(Logging) {
        level = LogLevel.INFO
    }
    install(HttpTimeout) {
        requestTimeoutMillis = 30_000
        connectTimeoutMillis = 15_000
    }
    install(DefaultRequest) {
        url(ApiConfig.BASE_URL)
        contentType(ContentType.Application.Json)
    }
}
